import React from 'react'
import styled from 'styled-components'

const StyleDiv = styled.div`
  && {
    font-size: 14px;
    background: #ededed;
    margin-bottom: 10px;
    text-align: center;
  }
  a:link,
  a:visited {
    color: #616161;
  }
`

export const Footer = () => (
  <StyleDiv className="ui">
    <a
      href="https://news.run24hrs.com/refund-policy/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Refund Policy
    </a>{' '}
    |{' '}
    <a
      href="https://news.run24hrs.com/data-protection-policy/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Data Protection Policy
    </a>
    |{' '}
    <a
      href="https://news.run24hrs.com/privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>{' '}
    |{' '}
    <a
      href="https://news.run24hrs.com/terms-and-conditions/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms and Conditions
    </a>{' '}
    |{' '}
    <a href="https://raceandrun.com/" target="_blank" rel="noopener noreferrer">
      เหรียญรางวัล
    </a>{' '}
    |{' '}
    <a
      href="https://news.run24hrs.com/%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%A3%E0%B8%B2/"
      target="_blank"
      rel="noopener noreferrer"
    >
      เกี่ยวกับเรา
    </a>
    <p>Copyright 2018-2019 Run24Hrs.com. All Rights Reserved.</p>
    <div>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.trustmarkthai.com/callbackData/popup.php?data=b4422-22-5-df3777ae049f21d086396450ae3f9fbee102f195&markID=firstmark"
      >
        <img
          style={{ width: 100 }}
          src="https://www.trustmarkthai.com//trust_banners/bns_registered.png"
          alt="กรมพัฒนาธุรกิจการค้า Trustmarkthai"
        />
      </a>
    </div>
  </StyleDiv>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer/index.js